import React from "react";
import "./Overview.css";
import {
  Activity,
  ArrowRight,
  Ban,
  Clock,
  GitPullRequest,
  Info,
  ShieldAlert,
  X,
  Gift,
  ShoppingCart,
  PhoneCall,
  ShieldCheck,
  Receipt,
  Wallet,
  BarChart2,
  TrendingUp,
} from "lucide-react";
import {
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
  ComposedChart,
} from "recharts";
import { FiMoreVertical, FiChevronDown } from "react-icons/fi";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
export default function Overview() {

const stats = [
  {
    title: "Active Incentives",
    value: "26",
    icon: "fa-solid fa-gift",
    bg: "#E6F7F4",
    trend: "+8%",
    trendType: "up",
  },
  {
    title: "Scheduled",
    value: "8",
    icon: "fa-solid fa-calendar",
    bg: "#F3E8FF",
    trend: "+14%",
    trendType: "up",
  },
  {
    title: "Draft",
    value: "5",
    icon: "fa-solid fa-file",
    bg: "#FFF4E5",
    trend: "No Change",
    trendType: "neutral",
  },
  {
    title: "Expired",
    value: "14",
    icon: "fa-solid fa-clock",
    bg: "#FDEAEA",
    trend: "-5%",
    trendType: "down",
  },
  {
    title: "Total Redemptions",
    value: "2,483",
    icon: "fa-solid fa-ticket",
    bg: "#E6F7F4",
    trend: "+18%",
    trendType: "up",
  },
  {
    title: "Budget Consumed",
    value: "68%",
    icon: "fa-solid fa-chart-pie",
    bg: "#FFF4E5",
    trend: "+5%",
    trendType: "up",
  },
  {
    title: "Profit Saved",
    value: "1,248 EGP",
    icon: "fa-solid fa-coins",
    bg: "#E8FBF8",
    trend: "+9%",
    trendType: "up",
  },
  {
    title: "Currently Paused",
    value: "6",
    icon: "fa-solid fa-pause",
    bg: "#FFF4E5",
    trend: "+1%",
    trendType: "up",
  },
  {
    title: "Pending Approval",
    value: "12",
    icon: "fa-solid fa-hourglass-half",
    bg: "#F3E8FF",
    trend: "+9%",
    trendType: "up",
  },
  {
    title: "Failed Redemptions",
    value: "37",
    icon: "fa-solid fa-xmark",
    bg: "#FDEAEA",
    trend: "+5%",
    trendType: "down",
  },
];

const data = [
  { name: "Apr 19", redemption: 300, revenue: 100, profit: 200 },
  { name: "Apr 26", redemption: 1100, revenue: 250, profit: 350 },
  { name: "May 03", redemption: 1600, revenue: 700, profit: 150 },
  { name: "May 15", redemption: 1200, revenue: 1100, profit: 600 },
  { name: "May 20", redemption: 2000, revenue: 1400, profit: 1000 },
];

  const incentivesData = [
  { name: "Weekend Oil Offer", value: 4.2 },
  { name: "Welcome2026", value: 3.8 },
  { name: "Battery Cashback", value: 2.5 },
  { name: "Competition 100", value: 1.6 },
];

const abusedData = [
  { name: "Welcome2026", value: 11 },
  { name: "Cashback Promo", value: 8 },
  { name: "Referral Program", value: 5 },
  { name: "Flash-Sale 50%", value: 2 },
];

const IncentivesCard = ({ title, data, type }) => {
  const max = Math.max(...data.map((i) => i.value));

  return (
    <div className="col-6">
      <div className="x9f-card-root me-3">
        {/* Header */}
        <div className="x9f-card-header">
          <h4>{title}</h4>
          <span className="x9f-view-all">View all →</span>
        </div>

        {/* List */}
        <div className="x9f-list-wrapper">
          {data.map((item, i) => {
            const width = (item.value / max) * 100;

            return (
              <div key={i} className="x9f-list-item">
                <div className="x9f-left">
                  <span className="x9f-index">{i + 1}</span>
                  <span className="x9f-name">{item.name}</span>
                </div>

                <div className="x9f-bar-wrapper">
                  <div className="x9f-bar-bg">
                    <div
                      className={`x9f-bar-fill ${
                        type === "abused" ? "x9f-bar-red" : "x9f-bar-green"
                      }`}
                      style={{ width: `${width}%` }}
                    />
                  </div>
                </div>

                <div className="x9f-value">
                  {type === "roi" ? `${item.value}x` : item.value}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

  const lossData = [
    { name: "Competition 2000", value: -3265 },
    { name: "Weekend Battery Offer", value: -2016 },
    { name: "Bundle X Discount", value: -1050 },
    { name: "Flash-Sale 20%", value: -565 },
  ];

  const conversionData = [
    { name: "Referral Program", value: 6.8 },
    { name: "Welcome2026", value: 5.2 },
    { name: "Bundle X Discount", value: 3.7 },
    { name: "Cashback Promo", value: 4.2 },
  ];

  const SimpleListCard = ({ title, data, type }) => {
    return (
      <div className="col-6">
        <div className="x9f-card-root me-3">
          {/* Header */}
          <div className="x9f-card-header">
            <h4>{title}</h4>
            <span className="x9f-view-all">View all →</span>
          </div>

          {/* List */}
          <div className="x9f-simple-list">
            {data.map((item, i) => (
              <div key={i} className="x9f-simple-item">
                <div className="x9f-left">
                  <span className="x9f-index">{i + 1}</span>
                  <span className="x9f-name">{item.name}</span>
                </div>

                <div
                  className={`x9f-value ${
                    type === "loss" ? "x9f-loss" : "x9f-conversion"
                  }`}
                >
                  {type === "loss"
                    ? `${item.value.toLocaleString()} EGP`
                    : `${item.value}%`}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="overview">
      {/* HEADER */}
      <div className="header">
        <div className="header-left">
          <input
            className="search"
            placeholder="Search incentive, codes, orders"
          />
        </div>

        <div className="header-right">
          <button className="incentive-btn create">
            <i className="fa-solid fa-plus"></i>
            Create Incentive
          </button>

          <button className="incentive-btn light">
            <i className="fa-regular fa-circle-play"></i>
            Simulation Mode
          </button>

          <button className="incentive-btn light">
            <i className="fa-solid fa-download"></i>
            Export Report
          </button>

          <button className="incentive-btn dangerr">
            <i className="fa-solid fa-power-off"></i>
            Emergency Freeze
          </button>
        </div>
      </div>
      {/* STATS */}
      <div className="stats-grid">
        {stats.map((item, i) => (
          <div className="stat-card" key={i}>
            <div className="stat-top">
              <div className="stat-icon" style={{ backgroundColor: item.bg }}>
                <i className={item.icon}></i>
              </div>

              <span className="stat-title">{item.title}</span>
            </div>

            <div className="stat-value">{item.value}</div>

            <div className="stat-bottom">
              <span className={`trend ${item.trendType}`}>{item.trend}</span>
              <span className="trend-text">vs last 30 days</span>
            </div>
          </div>
        ))}
      </div>
      {/* TABLE */}
      <div className="table-card">
        <div className="overview-table-header">
          <h3>Active Campaign Performance</h3>
          <span className="view-all">
            View all incentives <ArrowRight size={18} />
          </span>
        </div>
        <div className="table-wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Incentive Name</th>
                <th>Type</th>
                <th>Redemption</th>
                <th>Budget Used</th>
                <th>Funding Source</th>
                <th>Net Impact</th>
                <th>Conversion Rate</th>
                <th>Avg Order List</th>
                <th>Margin Status</th>
                <th>Last Redemption</th>
                <th>Status</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="name-cell">
                  <div className="avatar yellow">%</div>
                  <div>
                    <div className="name">Weekend Oil Offer</div>
                  </div>
                </td>
                <td>Offer</td>
                <td>624</td>
                <td>
                  <div className="overview-progress">
                    <div
                      className="progress-bar green"
                      style={{ width: "72%" }}
                    ></div>
                  </div>
                </td>
                <td>ESTBN</td>
                <td className="positive">+45,210 EGP</td>
                <td>6.8%</td>
                <td>+18%</td>
                <td>
                  <span className="ui-dot green"></span> Healthy
                </td>
                <td>July 20, 2025</td>
                <td>
                  <span className="badge active">Active</span>
                </td>
                <td>July 20, 2025</td>
                <td className="menu">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </td>
              </tr>
              {/* ROW 2 */}
              <tr>
                <td className="name-cell">
                  <div className="avatar black">%</div>
                  <div className="name">Welcome 2026</div>
                </td>
                <td>Promo Code</td>
                <td>405</td>
                <td>
                  <div className="overview-progress">
                    <div
                      className="progress-bar yellow"
                      style={{ width: "58%" }}
                    ></div>
                  </div>
                </td>
                <td>ESTBN</td>
                <td className="positive">+45,210 EGP</td>
                <td>6.8%</td>
                <td>+18%</td>
                <td>
                  <span className="ui-dot green"></span> Healthy
                </td>
                <td>July 20, 2025</td>
                <td>
                  <span className="badge active">Active</span>
                </td>
                <td>July 20, 2025</td>
                <td className="menu">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </td>
              </tr>
              {/* ROW 3 */}
              <tr>
                <td className="name-cell">
                  <div className="avatar teal">%</div>
                  <div className="name">Competition 100</div>
                </td>
                <td>Coupon</td>
                <td>112</td>
                <td>
                  <div className="overview-progress">
                    <div
                      className="progress-bar red"
                      style={{ width: "34%" }}
                    ></div>
                  </div>
                </td>
                <td>ESTBN</td>
                <td className="positive">+45,210 EGP</td>
                <td>6.8%</td>
                <td>+18%</td>
                <td>
                  <span className="ui-dot yellow"></span> Medium
                </td>
                <td>July 20, 2025</td>
                <td>
                  <span className="badge active">Active</span>
                </td>
                <td>July 20, 2025</td>
                <td className="menu">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* CHARTS SECTION */}
      <div className="charts-dashboard">
        <div className="row  ">
          {/* LEFT SIDE */}
          <div className="col-8 row gy-3 gx-0">
            {/* Budget */}
            <div className="col-6">
              <div className="budget-card me-3">
                {/* Header */}
                <div className="ui-card-header mb-1 pb-1">
                  <h4>Budget Utilization Overview</h4>
                  <FiMoreVertical size={18} />
                </div>
                {/* Divider */}
                <div className="ui-divider" />
                {/* Progress */}
                <div className="progress-section">
                  <div className="progress-wrapper-custom">
                    <CircularProgressbar
                      value={68}
                      strokeWidth={12}
                      styles={buildStyles({
                        pathColor: "#3FBEAC",
                        trailColor: "#E6E6E6",
                        strokeLinecap: "round",
                      })}
                    />

                    {/* Custom Text */}
                    <div className="progress-center-text">
                      <span className="progress-value">68%</span>
                      <span className="progress-sub">Budget Used</span>
                    </div>
                  </div>
                </div>
                {/* Details */}
                <div className="details">
                  <div className="row-item">
                    <div className="ui-left">
                      <span className="ui-dot ui-dot-used"></span>
                      Used (68%)
                    </div>
                    <div className="ui-right">68,340.00 EGP</div>
                  </div>
                  <div className="row-item">
                    <div className="ui-left">
                      <span className="ui-dot ui-dot-remaining"></span>
                      Remaining (32%)
                    </div>
                    <div className="ui-right">31,600.00 EGP</div>
                  </div>
                </div>
                <div className="ui-divider" />
                {/* Total */}
                <div className="total">
                  <div className="ui-left">
                    Total Budget
                    <span className="ui-growth">↑ 9%</span>
                    <span className="ui-sub">vs last 30 days</span>
                  </div>
                  <div className="ui-right fw-bold">100,000.00 EGP</div>
                </div>
                <div className="ui-divider" />
                {/* Forecast */}
                <div className="forecast">
                  <div className="ui-left">Forecast Exhaustion Date</div>
                  <div className="ui-right">May 24, 2025</div>
                </div>
                <p className="alert m-0 px-0 pt-2 pb-0">
                  Budget likely exhausted in 4 days
                </p>
              </div>
            </div>
            {/* Chart */}
            <div className="col-6">
              <div className="chart-card me-3">
                {/* Header */}
                <div className="ui-card-header">
                  <h4>Redemption Trend (Last 30 days)</h4>

                  <div className="dropdown">
                    30 days <FiChevronDown size={14} />
                  </div>
                </div>
                <div className="ui-divider" />
                {/* Legend */}
                <div className="legend">
                  <span>
                    <i className="ui-dot ui-dot-black"></i> Redemption
                  </span>
                  <span>
                    <i className="ui-dot ui-dot-purple"></i> Revenue (EGP)
                  </span>
                  <span>
                    <i className="ui-dot ui-dot-orange"></i> Profit (EGP)
                  </span>
                </div>
                {/* Chart */}
                <div className="chart-wrapper">
                  <ResponsiveContainer width="100%" height={300}>
                    <ComposedChart
                      data={data}
                      margin={{ top: 10, right: 10, left: 5, bottom: 0 }}
                    >
                      <CartesianGrid stroke="#eee" />
                      <XAxis
                        dataKey="name"
                        tick={{ fontSize: 12 }}
                        padding={{ left: 0, right: 0 }}
                      />
                      <YAxis
                        tick={{ fontSize: 12 }}
                        width={30}
                        axisLine={false}
                        tickLine={false}
                      />
                      <Tooltip />
                      {/* AREA (background like figma) */}
                      <Area
                        type="monotone"
                        dataKey="redemption"
                        fill="#3FBEAC33"
                        stroke="none"
                      />
                      {/* LINES */}
                      <Line
                        type="monotone"
                        dataKey="redemption"
                        stroke="#111"
                        strokeWidth={2}
                        dot={{ r: 4 }}
                      />
                      <Line
                        type="monotone"
                        dataKey="revenue"
                        stroke="#7B3FE4"
                        strokeWidth={2}
                        dot={{ r: 4 }}
                      />
                      <Line
                        type="monotone"
                        dataKey="profit"
                        stroke="#F59E0B"
                        strokeWidth={2}
                        dot={{ r: 4 }}
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
                {/* Footer */}
                <div className="footer">
                  <div className="ui-left">
                    Total Redemption
                    <span className="ui-growth">↑ 18%</span>
                    <span className="ui-sub">vs last 30 days</span>
                  </div>

                  <div className="ui-right">2,436.00</div>
                </div>
              </div>
            </div>
            {/* ROI & Abused Cards  */}
            <>
              <IncentivesCard
                title="Highest ROI Incentives"
                data={incentivesData}
                type="roi"
              />
              <IncentivesCard
                title="Most Abused Incentives"
                data={abusedData}
                type="abused"
              />
            </>
            {/* Loss & Conversion Cards  */}
            <>
              <SimpleListCard
                title="Top Loss-Making Incentives"
                data={lossData}
                type="loss"
              />
              <SimpleListCard
                title="Highest Conversion Incentives"
                data={conversionData}
                type="conversion"
              />
            </>
          </div>
          {/* RIGHT SIDE */}
          <div className="col-4 row gy-3 gx-0">
            <div className="zr-card-root">
              <div className="ui-card-header mt-2">
                <h4>Priority & Stacking Rules</h4>
                <span className="zr-manage-link">Manage rules →</span>
              </div>

              <div className="zr-sub-text">
                Last updated by Osama Ali • 2h ago
              </div>

              <div className="ui-divider" />

              <div className="zr-rules-list">
                {[
                  "Default = Non-Stackable",
                  "One Offer per Order",
                  "One Promo per Order",
                  "Offer > Promo > Voucher > Points > Taxes > Doorstep Fee",
                  "Taxes Excluded",
                  "Doorstep Fee Excluded",
                ].map((rule, i) => (
                  <div key={i} className="zr-rule-item">
                    <span className="zr-check">✓</span>
                    <span>{rule}</span>
                  </div>
                ))}
              </div>

              <div className="ui-divider" />

              <div className="zr-footer ">
                <span>Applied Scope:</span>
                <span className="zr-muted">
                  Global · All Incentive Types · All Orders
                </span>
              </div>
            </div>
            {/* Alerts */}
            <div className="zr-card-root">
              <div className="ui-card-header mb-1">
                <h4>Recent Alerts</h4>
                <span className="zr-manage-link">View all alerts →</span>
              </div>
              <div className="ui-divider" />
              <div className="zr-alerts-list mt-2">
                <div className="zr-alert-item warning">
                  <div className="zr-alert-icon">
                    <ShieldAlert color="#D97706" />{" "}
                  </div>
                  <span className="zr-alert-badge warning">Warning</span>
                  <span className="zr-alert-text">
                    Tire Flash Sale Budget Reached 85%
                  </span>
                  <span className="zr-time">12m ago</span>
                </div>

                <div className="zr-alert-item critical">
                  <div className="zr-alert-icon">
                    <Ban color="#A80101" />
                  </div>
                  <span className="zr-alert-badge critical">Critical</span>
                  <span className="zr-alert-text">
                    Full Stacking Blocked on Order <b>ORD-8421</b>
                  </span>
                  <span className="zr-time">26m ago</span>
                </div>

                <div className="zr-alert-item warning">
                  <div className="zr-alert-icon">
                    <ShieldAlert color="#D97706" />{" "}
                  </div>
                  <span className="zr-alert-badge warning">Warning</span>
                  <span className="zr-alert-text">
                    Voucher not valid for Battery Service
                  </span>
                  <span className="zr-time">1h ago</span>
                </div>

                <div className="zr-alert-item info">
                  <div className="zr-alert-icon">
                    <Info color="#3FBEAC" />
                  </div>
                  <span className="zr-alert-badge info">Info</span>
                  <span className="zr-alert-text">
                    Provider-funded offer awaiting approval
                  </span>
                  <span className="zr-time">2h min</span>
                </div>
              </div>
            </div>
            {/* Quick Health Center */}
            <div className="qh-card-root">
              <div className="ui-card-header my-1">
                <h4>Quick Health Center</h4>
              </div>
              <div className="ui-divider" />
              <div className="qh-grid">
                <div className="qh-item">
                  <div className="qh-icon blue">
                    <GitPullRequest color="#3E9FF6" />
                  </div>
                  <div>
                    <p className="qh-label">Conflicts Today</p>
                    <p className="qh-value">23</p>
                  </div>
                </div>
                <div className="qh-item">
                  <div className="qh-icon red">
                    {" "}
                    <Ban color="#A80101" />
                  </div>
                  <div>
                    <p className="qh-label">Blocked Incentives</p>
                    <p className="qh-value">6</p>
                  </div>
                </div>
                <div className="qh-item">
                  <div className="qh-icon red-light">
                    <X color="#A80101" />
                  </div>
                  <div>
                    <p className="qh-label">Failed Redemptions</p>
                    <p className="qh-value">37</p>
                  </div>
                </div>
                <div className="qh-item">
                  <div className="qh-icon orange">
                    <FingerprintIcon sx={{ fontSize: 32 }} />
                  </div>
                  <div>
                    <p className="qh-label">Fraud Attempts</p>
                    <p className="qh-value">11</p>
                  </div>
                </div>
                <div className="qh-item">
                  <div className="qh-icon yellow">
                    <Clock color="#FEB91E" />
                  </div>
                  <div>
                    <p className="qh-label">Pending Contributions</p>
                    <p className="qh-value">4</p>
                  </div>
                </div>
                <div className="qh-item">
                  <div className="qh-icon green">
                    {" "}
                    <Activity color="#3FBEAC" />
                  </div>
                  <div>
                    <p className="qh-label">System Health</p>
                    <p className="qh-value">Healthy</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer section */}
      <div className="row mt-3">
        <div className="col-6">
          <div className="footer-card">
            <div className="footer-card__header">
              <span className="footer-card__title">System Status</span>
              <span className="footer-card__subtitle">
                Last checked: 2 min ago
              </span>
            </div>
            <div className="footer-card__grid">
              {[
                {
                  icon: <Gift size={18} color="#3FBEAC" />,
                  label: "Incentives Engine",
                  value: "Operational",
                },
                {
                  icon: <ShoppingCart size={18} color="#3FBEAC" />,
                  label: "Redemption Service",
                  value: "Operatio...",
                },
                {
                  icon: <PhoneCall size={18} color="#3FBEAC" />,
                  label: "Budget Service",
                  value: "Operational",
                },
                {
                  icon: <ShieldCheck size={18} color="#3FBEAC" />,
                  label: "Fraud Detection",
                  value: "Operational",
                },
              ].map((item, i) => (
                <div className="footer-stat" key={i}>
                  <div className="footer-stat__icon">{item.icon}</div>
                  <span className="footer-stat__label">{item.label}</span>
                  <span className="footer-stat__value footer-stat__value--green">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="footer-card">
            <div className="footer-card__header">
              <span className="footer-card__title">Today's Summary</span>
            </div>
            <div className="footer-card__grid">
              {[
                {
                  icon: <Receipt size={18} color="#3FBEAC" />,
                  label: "Redemptions",
                  value: "184",
                  positive: false,
                },
                {
                  icon: <Wallet size={18} color="#3FBEAC" />,
                  label: "Revenue Impact",
                  value: "+245,600 EGP",
                  positive: true,
                },
                {
                  icon: <BarChart2 size={18} color="#3FBEAC" />,
                  label: "Profit Impact",
                  value: "+78,900 EGP",
                  positive: true,
                },
                {
                  icon: <TrendingUp size={18} color="#3FBEAC" />,
                  label: "Avg. Order List",
                  value: "+14%",
                  positive: true,
                },
              ].map((item, i) => (
                <div className="footer-stat" key={i}>
                  <div className="footer-stat__icon">{item.icon}</div>
                  <span className="footer-stat__label">{item.label}</span>
                  <span
                    className={`footer-stat__value ${item.positive ? "footer-stat__value--green" : ""}`}
                  >
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
